<template>
  <div id="event">
    <div v-if="isSelectedBot">
      <div class="container">
        <ul class="nav nav-tabs" style="padding-top: 15px">
          <li class="nav-item" :class="{ active: currentView == 'place' }">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'place'">Place</a>
          </li>
          <li class="nav-item" :class="{ active: currentView == 'floorplan' }">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'floorplan'"
              >Floorplan</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentView == 'schedule' }">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'schedule'"
              >Event</a
            >
          </li>
        </ul>
        <div class="tab-container">
          <br />
          <component :is="currentView"></component>
        </div>
      </div>
    </div>
    <div v-else>
      <template-empty></template-empty>
    </div>
  </div>
</template>

<script>
import templateEmpty from '@/components/view/template/template-empty'
import Place from './Place'
import Floorplan from './Floorplan'
import Schedule from './Schedule'

export default {
  data: function () {
    return {
      currentView: 'place'
    }
  },
  components: {
    'template-empty': templateEmpty,
    place: Place,
    floorplan: Floorplan,
    schedule: Schedule
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'place':
        case 'floorplan':
        case 'schedule':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'place'
          break
      }
    } else {
      vm.currentView = 'place'
    }
  },
  computed: {
    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/Event.vue